/*
  Pijlen voor de beeldcarrousel op de productkaart.

  De carrousel zelf werkt met scroll-snap, dus vegen werkt zonder dit script;
  de pijlen zijn de muis-variant daarvan.

  Dit staat in een gedeeld bestand en niet in een {% javascript %}-blok, omdat
  meerdere secties dezelfde kaart gebruiken — het collectieraster en de
  gerelateerde producten. In een sectieblok zou de code per sectie meekomen.
*/
class ProductCardSlider {
  constructor(card) {
    this.slides = card.querySelector('[data-product-card-slides]');
    if (!this.slides) return;

    this.media = card.querySelector('.product-card__media');

    const prev = card.querySelector('[data-product-card-prev]');
    const next = card.querySelector('[data-product-card-next]');
    if (!prev || !next) return;

    /*
      Pijlen alleen tonen als er echt meer dan één foto is. Dat wordt hier
      bepaald en niet in Liquid, omdat het aantal foto's per kaart verschilt
      tussen de product- en de kleurweergave.
    */
    if (this.slides.scrollWidth <= this.slides.clientWidth + 1) return;

    prev.hidden = false;
    next.hidden = false;
    prev.addEventListener('click', () => this.step(-1));
    next.addEventListener('click', () => this.step(1));
  }

  step(direction) {
    const width = this.slides.clientWidth;
    const max = this.slides.scrollWidth - width;
    let target = this.slides.scrollLeft + width * direction;

    // Rondlopen, zodat een pijl nooit in een dood einde eindigt.
    if (target > max + 1) target = 0;
    if (target < 0) target = max;

    /*
      De hover-overgang naar de tweede foto hoort alleen te werken zolang de
      eerste foto in beeld staat. Sta je met de pijlen bij foto drie, dan heb
      je zelf gekozen en zou een foto die eroverheen komt uit het niets
      verschijnen. Het is een kenmerk en geen scroll-luisteraar, omdat de
      pijlen de enige manier zijn om met een muis te bladeren.
    */
    this.media?.toggleAttribute('data-scrolled', target > 1);

    this.slides.scrollTo({ left: target, behavior: 'smooth' });
  }
}

/*
  Ook aanroepbaar nadat er kaarten zijn bijgeplaatst — de aanbevelingen worden
  na het laden van de pagina opgehaald. Kaarten die al ingericht zijn, worden
  overgeslagen.
*/
window.initProductCards = function initProductCards(root = document) {
  root.querySelectorAll('.product-card:not([data-card-ready])').forEach((card) => {
    card.setAttribute('data-card-ready', '');
    new ProductCardSlider(card);
  });

  // Hartjes van net ingevoegde kaarten in lijn brengen met de opslag.
  window.wishlist?.sync();
};

window.initProductCards();

/*
  De schakelaar product / model zet alleen een kenmerk op de pagina; welke foto
  vooraan komt is verder een kwestie van opmaak. De keuze wordt onthouden, zodat
  hij blijft staan als je een product bekijkt en terugkomt.
*/
const CARD_VIEW_KEY = 'card-image-view';

function syncCardView() {
  const view = document.documentElement.dataset.cardImage || 'product';
  document.querySelectorAll('[data-card-view]').forEach((button) => {
    button.setAttribute('aria-pressed', button.dataset.cardView === view);
  });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-card-view]');
  if (!button) return;

  document.documentElement.dataset.cardImage = button.dataset.cardView;

  /*
    De volgorde wisselt meteen, maar de carrousel scrolt mee: met scroll-snap
    houdt de browser de foto vast die in beeld staat, en die schuift een plek
    op. Je zou dus niets zien veranderen. Daarom terug naar het begin.
  */
  requestAnimationFrame(() => {
    document.querySelectorAll('[data-product-card-slides]').forEach((slides) => {
      slides.scrollTo({ left: 0, behavior: 'instant' });
    });
  });

  try {
    localStorage.setItem(CARD_VIEW_KEY, button.dataset.cardView);
  } catch (error) {
    // Privémodus: dan onthouden we het gewoon niet.
  }
  syncCardView();
});

syncCardView();
